<template>
  <form-section id="duration_and_resignation" :headline="$t('form.duration_and_resignation.legend')">
    <radio-group name="duration-type" :options="durationOptions" v-model="durationAndResignation.selectedDuration" :label="$t('form.duration_and_resignation.duration.label')" />

    <datepicker-wrapper v-if="showEarliestResignation" id="earliest_resign" :label="$t('form.duration_and_resignation.earliest_resignation.label')">
      <datepicker
        id="earliest_resign"
        input-class="form-control datepicker"
        :placeholder="$t('form.duration_and_resignation.earliest_resignation.placeholder')"
        format="dd/MM/yyyy"
        @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
        v-model="durationAndResignation.earliestResignation"
        :language="lang"
      ></datepicker>
    </datepicker-wrapper>

    <datepicker-wrapper v-if="showFromDate" id="limited_from_date" :label="$t('form.duration_and_resignation.from_date.label')">
      <datepicker
        id="limited_from_date"
        input-class="form-control datepicker"
        :placeholder="$t('form.duration_and_resignation.from_date.placeholder')"
        format="dd/MM/yyyy"
        @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
        v-model="durationAndResignation.fromDate"
        :language="lang"
      ></datepicker>
    </datepicker-wrapper>

    <datepicker-wrapper v-if="showToDate" id="limited_to_date" :label="$t('form.duration_and_resignation.to_date.label')">
      <datepicker
        id="limited_to_date"
        input-class="form-control datepicker"
        :placeholder="$t('form.duration_and_resignation.to_date.placeholder')"
        format="dd/MM/yyyy"
        @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
        v-model="durationAndResignation.toDate"
        :language="lang"
      ></datepicker>
    </datepicker-wrapper>
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection.vue";
import DatepickerWrapper from "@/shared/components/DatepickerWrapper.vue";
import Textfield from "@/shared/components/Textfield.vue";
import RadioGroup from "@/shared/components/RadioGroup.vue";

import Datepicker from "vuejs-datepicker";
import { da } from "vuejs-datepicker/dist/locale";

export default {
  components: {
    FormSection,
    Datepicker,
    DatepickerWrapper,
    Textfield,
    RadioGroup
  },
  data() {
    return {
      lang: da,
      durationAndResignation: {
        selectedDuration: this.$t("form.duration_and_resignation.duration.options.unlimited"),
        earliestResignation: "",
        fromDate: "",
        toDate: "",
        period: "",
        notice: {
          firstPeriod: "",
          otherPeriod: ""
        }
      }
    };
  },
  computed: {
    durationOptions() {
      return [this.$t("form.duration_and_resignation.duration.options.unlimited"), this.$t("form.duration_and_resignation.duration.options.limited_auto_renew")];
    },
    showEarliestResignation() {
      return this.durationAndResignation.selectedDuration === this.$t("form.duration_and_resignation.duration.options.unlimited") && this.isDistributor;
    },
    showPeriod() {
      return this.durationAndResignation.selectedDuration === this.$t("form.duration_and_resignation.duration.options.limited_auto_renew");
    },
    showFromDate() {
      let selectedDuration = this.durationAndResignation.selectedDuration;
      return selectedDuration === this.$t("form.duration_and_resignation.duration.options.limited_auto_renew");
    },
    showToDate() {
      let selectedDuration = this.durationAndResignation.selectedDuration;
      return selectedDuration === this.$t("form.duration_and_resignation.duration.options.limited_auto_renew");
    },
    isDistributor() {
      return this.$store.getters.isDistributorType;
    }
  },
  watch: {
    durationAndResignation: {
      handler() {
        this.$store.commit("updateDurationAndResignation", this.durationAndResignation);
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/DurationAndResignation.vue